<template>
  <div class="h-32">
    <div
      ref="chart"
      class="h-10"
    />
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import { getAdminGlobalData } from "@/component/cdevs/allFunctions";

export default {
  name: "StackedBarChart",
  created() {
    this.getData()
  },
  data() {
    return {
      stats: {

        serviceRequest: 0,
        awaitServiceRequest: 0,
      },
      charge: false // Indicateur de chargement
    };
  },

  methods: {
    async getData() {
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        startDate: "12/02/2020",
        endDate: "12/02/2025"
      };
      try {
        const response = await getAdminGlobalData(data);
        // console.log(response);
        this.stats = {
          serviceRequest: response.serviceRequest || 0,
          awaitServiceRequest: response.awaitServiceRequest || 0,
        };
        this.renderChart();
      } catch (error) {
        // console.error("Erreur lors de la récupération des données :", error);
        this.$toast.error("Une erreur est survenue");
      } finally {
        this.charge = false;
      }
    },

    renderChart() {
      const enAttente = this.stats.awaitServiceRequest;
      const traitee = this.stats.serviceRequest - this.stats.awaitServiceRequest;

      const options = {
        series: [
          {
            name: "EN ATTENTE",
            data: [enAttente] ,
            color: "#241A72",
          },
          {
            name: "TRAITÉE",
            data: [traitee],
            color: "#7BD0FF",
          },
        ],
        chart: {
          type: "bar",
          height: 120,
          stacked: true,
          stackType: "100%",
          toolbar: {
           show: false
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "200%",
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val}`,
          },
        },
        fill: {
          opacity: 1,
        },
          legend: {
            position: "bottom",
            horizontalAlign: "left",
            formatter: (seriesName, opts) => {
              const seriesIndex = opts.seriesIndex;
              const seriesValue = opts.w.globals.series[seriesIndex][0];
              return `${seriesName} (${seriesValue})`;
            },
          },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          show: false,
        },
        grid: {
          show: false,
        },
      };
      const chart = new ApexCharts(this.$refs.chart, options);
      chart.render();
    }
  }
};
</script>

<style scoped>
#chart {
  width: 100%;
  height: 100%;
}
</style>
